import React from "react";
// import "./WhiteBoardContents.css"

class EsPatternsContents extends React.Component {
    constructor(props) {
        /* We MUST call the parent class contructor and send it the props object */
        super(props);

        // Setting the initial state of the NormalForms component
        this.state =
            {
                contents: this.props.value
            };

        }

        onSingletonMonostateDesignClick = () =>
        {
            this.props.switcher(1);
        }

        
       
    render() {
        return (

            <div className='TlDrContents scroll-div'>

            <h2>Contents: </h2> 
            <br/>
            <p className="Bullet"> ▶      </p>
            <p className="ContentItem" onClick={this.onSingletonMonostateDesignClick}>Singleton / Monostate Design Pattern</p>
             <br/>
             <br/>

            
           
            </div>

        )

    }

}

export default EsPatternsContents;



// WEBPACK FOOTER //
// ./src/components/EsPatterns/EsPatternsContent.js